import React, { useEffect, useState } from "react";
import "../../styles/ourCompanies/styles.scss";

const OurCompaniesComponent = () => {
  const images = [
    "/images/ourCompanies/guvi.svg",
    "/images/ourCompanies/bluefunda.svg",
    "/images/ourCompanies/agnoshin.svg",
    "/images/ourCompanies/provassure.svg",
    "/images/ourCompanies/sudoboat.svg",
    "/images/ourCompanies/laweLogo.svg",
    "/images/ourCompanies/medsy-removebg.png",
    "/images/ourCompanies/questionCloud.png",
    "/images/ourCompanies/BlueSiliconInfotech.jpg",
  ].map((image, index) => ({
    id: index,
    image,
  }));
  let speed = 30000;
  return (
    <div className="our-companies-wrapper">
      <div className="our-companies-heading">
        Trusted by industry-leading companies
      </div>
      <div className="inner">
        <div className="wrapper">
          <section style={{ "--speed": `${speed}ms` }}>
            {images.map(({ id, image }) => (
              <div
                className={id === 5 ? "image-style image" : "image"}
                key={id}
              >
                <img src={image} alt={id} />
              </div>
            ))}
          </section>
          <section style={{ "--speed": `${speed}ms` }}>
            {images.map(({ id, image }) => (
              <div
                className={id === 5 ? "image-style image" : "image"}
                key={id}
              >
                <img src={image} alt={id} />
              </div>
            ))}
          </section>
          <section style={{ "--speed": `${speed}ms` }}>
            {images.map(({ id, image }) => (
              <div
                className={id === 5 ? "image-style image" : "image"}
                key={id}
              >
                <img src={image} alt={id} />
              </div>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
};

export default OurCompaniesComponent;
